/**
 * Tab-Switcher zwischen Listen-, Kalender- und Übersichts-Ansicht.
 */

import { NavLink } from 'react-router-dom';

const linkClass = ({ isActive }: { isActive: boolean }) =>
  [
    'flex-1 text-center text-sm py-2 rounded transition !min-h-0',
    isActive ? 'bg-brand text-white' : 'bg-slate-800 hover:bg-slate-700 text-slate-200',
  ].join(' ');

export function ViewSwitcher() {
  return (
    <div className="flex gap-1 bg-slate-900 rounded-lg p-1 max-w-md mx-auto mb-3">
      <NavLink to="/" end className={linkClass}>
        Liste
      </NavLink>
      <NavLink to="/kalender" className={linkClass}>
        Kalender
      </NavLink>
      <NavLink to="/uebersicht" className={linkClass}>
        Übersicht
      </NavLink>
    </div>
  );
}
